import {
  FETCH_META_COMPONENT_REQUEST,
  FETCH_META_COMPONENT_SUCCESS,
  FETCH_META_COMPONENT_FAILURE,
} from '../../constants/ActionTypes';
import { dataCheck, getPrev } from '../../helpers/table-api';
import { errorExtractor, getFormattedPageHash, setUrlHash } from '../../utils';
import metaComponentsApi from '../../api/meta-components';
import { isCurruntMetaComponentFetching } from './getters';

const setPageHash = (pageNo = 1) => {
  const pageHash = getFormattedPageHash();
  const { page: pageNoCached = 1 } = pageHash;

  if (pageNo !== pageNoCached) {
    setUrlHash({
      ...pageHash,
      page: pageNo,
    });
  }
};

export const fetchMetaList =
  (endpoint, pageNo) => async (dispatch, getState) => {
    try {
      if (isCurruntMetaComponentFetching(getState(), endpoint)) {
        return Promise.resolve();
      }

      dispatch({
        type: FETCH_META_COMPONENT_REQUEST,
        name: endpoint,
      });

      let data = await metaComponentsApi.getMetaList(endpoint, pageNo);
      const check = dataCheck(data);
      const prev = getPrev(data);
      data = check ? data : await metaComponentsApi.getMetaList(endpoint, prev);

      dispatch({
        type: FETCH_META_COMPONENT_SUCCESS,
        name: endpoint,
        data: data,
      });

      return Promise.resolve();
    } catch (error) {
      const processedError = errorExtractor(error);

      dispatch({
        type: FETCH_META_COMPONENT_FAILURE,
        name: endpoint,
        data: processedError,
      });

      return Promise.reject(processedError);
    } finally {
      setPageHash(pageNo);
    }
  };
